/**
 * The external dependencies.
 */
import {isEmpty} from 'ramda';

/**
 * Check if the user is logged in.
 *
 * @param  {Object}  state
 * @return {Boolean}
 */
export const isLoggedIn = (state) => !isEmpty(state.auth.user);

/**
 * Get the current user data.
 *
 * @param  {Object}  state
 * @return {Boolean}
 */
export const getAuthUser = ({auth: {user}}) => user;

export const isQuality = ({auth: {quality}}) => quality;
export const isDispo = ({auth: {disponent}}) => disponent;
export const isOpmanager = ({auth: {opmanager}}) => opmanager;
export const freeUser = ({auth: {freeUser}}) => freeUser;

export const combineAuth = ({auth: {user, quality, disponent, freeUser}}) => {
    return {user, quality, disponent, freeUser}
};


export const getConfig = ({auth: {config}}) => config;
export const displayshop = ({auth: {config, disponent, quality}}) => {
    return config['displayshop'] === 'true' || disponent || quality;
}

export const randomWorksteps = ({auth: {randomWorksteps}}) => randomWorksteps
export const noworkplace = ({auth: {noworkplace}}) => noworkplace
export const disponentnext = ({auth: {disponentnext}}) => disponentnext
export const filterlastworkstep = ({auth: {config}}) => {
    if (config['filterlastworkstep'] === 'true'){
        return true;
    }
    return false;
}
export const displayscrapbutton = ({auth: {config}}) => {
    if (config['displayscrapbutton'] === 'true'){
        return true;
    }
    return false;
}
export const displaycurrentstep = ({auth: {config}}) => {
    if (config['displaycurrentstep'] === 'false'){
        return false;
    }
    return true;
}
export const extendtileinformation = ({auth: {config}}) => {
    if (config['extendtileinformation'] === 'true'){
        return true;
    }
    return false;
}
export const getFilterbysteps = ({auth: {config}}) => {
    if (config['filterbysteps'] === 'true'){
        return true;
    }
    return false;
}
export const getDisplayDoneTab = ({auth: {config}}) => {
    if (config['displaydonetab'] === 'true'){
        return true;
    }
    return false;
}
export const labelconfig = ({auth: {config}}) => {
    if (config['labelconfig'] === '[]' || config['labelconfig'] === null || config['labelconfig'] === undefined){
        return [];
    } else {
        let value = JSON.parse(config['labelconfig']);
        return value;
    }
}



// WEBPACK FOOTER //
// ./src/store/auth/selectors.js